import React, { useContext } from 'react';
import { ConfigContext } from '../../../../Contexts/ConfigContext';
import PageHeading from '../../../../Components/PageHeading';
//mui imports====
import InputLabel from '@mui/material/InputLabel';
import useCommonStyles from '../../../../commonStyles';
import Typography from '@mui/material/Typography';
import { Paper, Grid } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
//===============

const VideoAutoPlayConfig = ({ keyData , featureDescription}) => {
	const commonStyleClasses = useCommonStyles();
	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="Video Auto Play"
				headingPath={['Dashboard', 'Framerate', 'FeaturesData', 'Video Auto Play']}
				description="Manage Platform wise Video Auto Play Configuration"
				showInfoButton = {true}
				infoMessage={featureDescription}
			/>
			<Grid container spacing={1} style={{ width: '94.5%', margin: '3rem auto 0 auto' }}>
				<Grid item xs={4}>
					<DeviceConfig keyData={keyData + '.DESKTOP.autoplay'} deviceType="Desktop" />
				</Grid>
				<Grid item xs={4}>
					<DeviceConfig keyData={keyData + '.MOBILE.autoplay'} deviceType="Mobile" />
				</Grid>
				<Grid item xs={4}>
					<DeviceConfig keyData={keyData + '.TABLET.autoplay'} deviceType="Tablet" />
				</Grid>
			</Grid>
		</Paper>
	);
};

//Config Component that only configures width and height ( Pass keyData and device Type(["Desktop"|"Mobile"|"Tablet"]) as props )
const DeviceConfig = ({ keyData, deviceType }) => {
	const commonStyleClasses = useCommonStyles();

	const { rawConfig, updateRawConfig } = useContext(ConfigContext); //rawConfig from ConfigContext
	return (
		<Grid
			container
			spacing={1}
			className={commonStyleClasses.basicOutlinedBox}
			style={{ width: '90%' }}
		>
			<Grid item xs={12} style={{ marginBottom: '2rem' }}>
				<Typography fontWeight={600} variant="h4">
					{deviceType}
				</Typography>
			</Grid>
			<Grid item xs={12}>
				<FormControl variant="outlined" style={{ marginBottom: '2rem', width: '100%' }}>
					<InputLabel id={`${keyData}-${deviceType}-input-width-label`}>AutoPlay</InputLabel>
					<Select
						labelId={`${keyData}-${deviceType}-input-width-label`}
						id={`${keyData}-${deviceType}-input-width`}
						value={rawConfig[keyData] ? rawConfig[keyData] : false}
						label="Width"
						onChange={(e) => {
							updateRawConfig({
								...rawConfig,
								[keyData]: e.target.value
							});
						}}
						style={{ backgroundColor: 'white' }}
					>
						<MenuItem value={'muted'}>on</MenuItem>
						<MenuItem value={false}> off</MenuItem>
					</Select>
				</FormControl>
			</Grid>
		</Grid>
	);
};

export default VideoAutoPlayConfig;
